import { useRef, useState } from "react";
import { Camera, ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { uploadImage, fileUrl, formatApiError } from "@/lib/api";
import { CameraDialog } from "@/components/CameraDialog";

export function PhotoPicker({ photos, onChange, max = 20, testid = "wh-photos" }) {
  const [cam, setCam] = useState(false);
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  const add = async (blobs) => {
    setBusy(true);
    const out = [...photos];
    for (const b of blobs) {
      if (out.length >= max) break;
      try { out.push(await uploadImage(b, "articolo.jpg")); } catch (e) { toast.error(formatApiError(e)); }
    }
    onChange(out);
    setBusy(false);
  };
  const onFiles = (e) => { const fs = [...(e.target.files || [])]; e.target.value = ""; if (fs.length) add(fs); };
  return (
    <div className="space-y-3" data-testid={testid}>
      {photos.length > 0 && (
        <div className="grid grid-cols-3 sm:grid-cols-5 gap-2">
          {photos.map((p, i) => (
            <div key={p} className="relative">
              <img src={fileUrl(p)} alt={`Foto ${i + 1}`} className="aspect-square w-full object-cover rounded-xl border" />
              {i === 0 && max > 1 && <span className="absolute left-1 top-1 text-[10px] bg-[var(--ink)] text-white rounded px-1.5 py-0.5">Principale</span>}
              <button type="button" onClick={() => onChange(photos.filter((x) => x !== p))} className="absolute right-1 top-1 h-6 w-6 grid place-items-center rounded-full bg-white/90 border" aria-label="Rimuovi foto" data-testid={`${testid}-remove-${i}`}><X className="h-3.5 w-3.5" /></button>
            </div>
          ))}
        </div>
      )}
      {photos.length < max && (
        <div className="flex flex-wrap gap-2">
          <button type="button" onClick={() => setCam(true)} disabled={busy} className="btn-primary h-10 px-4 text-sm" data-testid={`${testid}-camera`}><Camera className="h-4 w-4" /> Scatta foto</button>
          <button type="button" onClick={() => ref.current.click()} disabled={busy} className="btn-secondary h-10 px-4 text-sm" data-testid={`${testid}-gallery`}><ImagePlus className="h-4 w-4" /> Galleria / PC</button>
          {busy && <Loader2 className="h-5 w-5 animate-spin self-center" />}
        </div>
      )}
      <input ref={ref} type="file" accept="image/*" multiple={max > 1} className="hidden" onChange={onFiles} data-testid={`${testid}-input`} />
      <CameraDialog open={cam} onOpenChange={setCam} title="Foto articolo" onCapture={(b) => add([b])} />
    </div>
  );
}
